import React, { createContext, ReactElement, useEffect, useState } from "react";

interface DrawerContextProviderProps {
  children: ReactElement;
}

interface DrawerContextProps {
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
}

const DrawerContext = createContext({} as DrawerContextProps);

function DrawerContextProvider({ children }: DrawerContextProviderProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  return (
    <DrawerContext.Provider value={{ isDrawerOpen, toggleDrawer }}>
      {children}
    </DrawerContext.Provider>
  );
}

export { DrawerContextProvider, DrawerContext };
